/**
 * ColorPickerCheckboard  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IColorPickerCheckboardProps extends React.ComponentPropsWithRef<"div"> {}

export const ColorPickerCheckboard: React.FC<IColorPickerCheckboardProps> = React.forwardRef(
	({ className, ...props }, ref) => {
		const baseClass = BEM("edt-color-picker-checkboard");

		if (className) {
			baseClass.add(className);
		}

		return <div className={baseClass.toClassName()} ref={ref} {...props} />;
	}
);
